module.exports = __webpack_public_path__ + "static/media/star.cf95d3fc.gif";